import PresentedByLogo from 'components/PresentedByLogo';
import Link from 'next/link';
import type { JSX } from 'react';
import useBreakpoint from 'hooks/useBreakpoint';
import * as S from './HubSponsorStyles';
import { parseHref } from '../Globals/Base/Link';

export interface SponsorProps {
  name: string;
  sponsorEnabled?: boolean;
  thumbnail: JSX.Element | string | null;
  link: string;
  sponsorType?: string;
  className?: string;
  topicSlug?: string;
}

const HubSponsor = ({ link, name, thumbnail, sponsorType, className, topicSlug, sponsorEnabled }: SponsorProps) => {
  const isMobile = useBreakpoint('smMax');
  const displayLogo =
    typeof thumbnail === 'string' ? (
      <PresentedByLogo
        src={thumbnail}
        height={isMobile ? '32' : '36'}
        width='auto'
        altText={name || ''}
      />
    ) : (
      thumbnail
    );

  if (!thumbnail || !sponsorEnabled) {
    return null;
  }

  let text = 'Brought to you by';
  if (sponsorType?.toLowerCase() === 'sponsor') {
    text = 'Presented By';
  }
  if (topicSlug && topicSlug === 'leadership-next') {
    text = 'Powered By';
  }

  return (
    <S.Wrapper
      data-cy='hub-sponsor'
      className={className}
    >
      <S.Title>{text}</S.Title>
      {name && !thumbnail && <S.Text>{name}</S.Text>}
      {link ? (
        <Link
          className='banner-link'
          href={parseHref(link)}
        >
          {displayLogo}
        </Link>
      ) : (
        <span className='banner-link'>{displayLogo}</span>
      )}
    </S.Wrapper>
  );
};

export default HubSponsor;
